(function() {
  $(document).on('click', '[data-behavior="submit"]', function(evt) {
    return $(this).closest('form').submit();
  });

}).call(this);
